const csvSafeCell = (value) => {
  let str = String(value ?? '');
  // Neutralize spreadsheet formula injection (=, +, -, @ as leading char)
  if (/^[=+\-@]/.test(str)) {
    str = `'${str}`;
  }
  if (/[",\n]/.test(str)) {
    str = `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

export const downloadCSV = ({ headers, rows, filename }) => {
  const csvContent = [
    headers.map(csvSafeCell).join(','),
    ...rows.map(row => row.map(csvSafeCell).join(','))
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
};
